<template>
  <Dialog :visible="showCard" modal class="mx-2 sm:mx-4 black-bg travel-buddy-dialog" :style="{ width: '50rem' }">
    <div class="flex min-h-fit w-full justify-center items-center">
      <i class="text-sm sm:text-base"> {{ $t('TravelBuddy.planMeeting') }}</i>
    </div>
    <h4 class="pl-2 sm:pl-6 my-2 text-base sm:text-lg">Agenda</h4>
    <div class="w-full pl-2 sm:pl-6">
      <div class="flex flex-row w-full min-h-5 mb-2 text-sm sm:text-base">
        <span>{{ $t('TravelBuddy.meetingArrival', {text: featureName}) }}</span>
      </div>
      <div class="flex flex-row w-full min-h-5 mb-2 ml-0 sm:ml-4">
        <ol class="list-decimal pl-4">
          <li class="text-sm sm:text-base">{{ $t('TravelBuddy.meetingQ1') }}</li>
          <li class="text-sm sm:text-base">{{ $t('TravelBuddy.meetingQ2') }}</li>
        </ol>
      </div>
    </div>
    <div class="flex flex-col-reverse sm:flex-row float-none sm:float-right gap-2 sm:gap-3 mt-6 sm:mt-16">
      <Button :label="$t('TravelBuddy.proceed')" class="btn-primary-accent w-full sm:w-auto px-4 py-2 sm:py-1 text-sm sm:text-base" @click.stop="markMeeting('completed')" unstyled />
      <!--Button :label="$t('TravelBuddy.markAsDone')" class="btn-primary-accent w-full sm:w-auto px-4 py-2 sm:py-1 text-sm sm:text-base" @click.stop="markMeeting('completed')" unstyled />
      <Button :label="$t('TravelBuddy.skip')" class="btn-secondary w-full sm:w-auto px-4 py-2 sm:py-1 text-sm sm:text-base" @click.stop="markMeeting('skipped')" unstyled /-->
    </div>
    <TravelBuddyFeedbackOverlayComponent v-if="showFeedbackDialog" :visible="showFeedbackDialog"
      @update:visible="showFeedbackDialog = $event" @close-parent="closeParentPopup">
    </TravelBuddyFeedbackOverlayComponent>
  </Dialog>

</template>
<script>
import { Button, Dialog } from 'primevue';
import TravelBuddyFeedbackOverlayComponent from '../Shared/FrontendOverlays/TravelBuddyFeedbackOverlayComponent.vue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';
export default {
  name: 'TravelBuddyExpandedCardComponent',
  components: { Dialog, Button, TravelBuddyFeedbackOverlayComponent },
  props: {
    showCard: Boolean,
  },
  data() {
    return {
      showFeedbackDialog: false,
      status: 'created',
    };
  },
  computed: {
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'travelBuddyHistory',
        this.$t('FallbackTexts.travelBuddyHistory'),
        this.$i18n?.locale,
      );
    },
  },
  methods: {
    async markMeeting(meetingStatus) {
      try {
        this.showFeedbackDialog = true;
        //this.status = meetingStatus;
        this.$store.commit('setTravelBuddyMeetingStatus', meetingStatus);
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error!',
          detail: '',
          life: 3000,
        });
      }
    },
    closeParentPopup() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped>
@media (max-width: 640px) {
  :deep(.p-dialog) {
    width: calc(100vw - 1rem) !important;
    max-width: calc(100vw - 1rem);
  }
}
</style>
